// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"g8FTv":[function(require,module,exports) {
var _common = require("./common");
var trans;
$("document").ready(function() {
    translatePage();
    initClickListeners();
    window.onclick = function(event) {
        if (!event.target.matches(".dropbtn")) {
            var dropdowns = document.getElementsByClassName("dropdown-content");
            var i;
            for(i = 0; i < dropdowns.length; i++){
                var openDropdown = dropdowns[i];
                if (openDropdown.classList.contains("show")) openDropdown.classList.remove("show");
            }
        }
    };
});
function openNav() {
    document.getElementById("closeNav").style.display = "block";
    var sidePanel = document.getElementById("resTopnav");
    sidePanel.style.display = "block";
}
function initClickListeners() {
    myTopnav.querySelector(".icon").addEventListener("click", function() {
        openNav();
    });
    btnTranslate.addEventListener("click", function() {
        showDropdown();
    });
    aEn.addEventListener("click", function() {
        translatePage("en");
    });
    aEs.addEventListener("click", function() {
        translatePage("es");
    });
    document.getElementById("closeNav").addEventListener("click", function() {
        closeNav();
    });
}
function showDropdown() {
    document.getElementById("langDropdown").classList.toggle("show");
}
var language = {
    eng: {
        Chat: "Chat",
        Feat: "Features",
        Download: "Download",
        About: "About",
        idiom: "En",
        errorPage: "Uh Oh, The page you were looking for does not exist or was deleted."
    },
    es: {
        Chat: "Chat",
        Feat: "Funciones",
        Download: "Descargar",
        About: "Sobre",
        idiom: "Es",
        errorPage: "Uh Oh, la p\xe1gina que estabas buscando no existe o fue eliminada."
    }
};
function translatePage(lang) {
    var translate = false;
    if (lang) {
        if (lang.includes("es")) {
            if (trans && trans.idiom == "Es") return;
            trans = language.es;
            document.getElementsByTagName("html")[0].setAttribute("lang", "es");
            var langs = langDropdown.querySelectorAll("a");
            langs[0].className = langs[0].className.replace(" set", "");
            langs[1].className += " set";
            (0, _common.setCookie)("lang", "es", 365);
        } else {
            if (trans && trans.idiom == "En") return;
            trans = language.eng;
            document.getElementsByTagName("html")[0].setAttribute("lang", "en");
            var langs = langDropdown.querySelectorAll("a");
            langs[0].className += " set";
            langs[1].className = langs[1].className.replace(" set", "");
            (0, _common.setCookie)("lang", "en", 365);
        }
        translate = true;
    } else if ((0, _common.getCookie)("lang") != "") {
        if ((0, _common.getCookie)("lang").includes("es")) {
            trans = language.es;
            document.getElementsByTagName("html")[0].setAttribute("lang", "es");
            var langs = langDropdown.querySelectorAll("a");
            langs[0].className = langs[0].className.replace(" set", "");
            langs[1].className += " set";
            translate = true;
            (0, _common.setCookie)("lang", "es", 365);
        } else trans = language.eng;
    } else if (navigator.language && navigator.language.includes("es")) {
        trans = language.es;
        document.getElementsByTagName("html")[0].setAttribute("lang", "es");
        var langs = langDropdown.querySelectorAll("a");
        langs[0].className = langs[0].className.replace(" set", "");
        langs[1].className += " set";
        translate = true;
    } else trans = language.eng;
    if (translate) {
        menuLang.textContent = trans.idiom;
        navChat.textContent = trans.Chat;
        navFeat.textContent = trans.Feat;
        navDownload.textContent = trans.Download;
        navAbout.textContent = trans.About;
        resChat.textContent = trans.Chat;
        resFeat.textContent = trans.Feat;
        resDownload.textContent = trans.Download;
        resAbout.textContent = trans.About;
        document.querySelector("h2").textContent = trans.errorPage;
    }
}

},{"./common":"loJev"}]},["g8FTv"], "g8FTv", "parcelRequire460e")

//# sourceMappingURL=404.8c088da8.js.map
